exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contentsModule[data-v-63928a14] {\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.contentsModule .collapse[data-v-63928a14]:not(.show) {\n  display: block;\n  height: 1.5rem;\n  overflow: hidden;\n}\n", ""]);

// exports
